import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { isIndividualHiddenFinancePath } from '@/app/navigation-context/individual-finance-nav.js';
import { useNavigationContext } from '@/app/navigation-context/use-navigation-context.js';
import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';

export function RequireCompanyFinance({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  const { level } = useNavigationContext();
  const location = useLocation();

  if (status === 'loading') {
    return null;
  }

  if (status !== 'authenticated' || !user) {
    return <Navigate to={appPaths.login} replace />;
  }

  if (user.personKind === 'INDIVIDUAL' && isIndividualHiddenFinancePath(location.pathname)) {
    return <Navigate to={level === 'place' ? appPaths.caixa : appPaths.org} replace />;
  }

  return children;
}
